import Cookies from 'js-cookie';

const modals = document.querySelectorAll('[data-modal-open]');

const updateAsa = (a, b) => {
  if (typeof asa_update === 'undefined') {
    return;
  }
  asa_update(a, b);
};

const modal = () => {
  if (!modals) {
    return;
  }

  modals.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const modal = document.getElementById(trigger.dataset.modalOpen);

      // Customize Content
      const modalRatingH2 = document.querySelector('.modal__title');
      const modalRatingPreTitle = document.querySelector('.modal__pre-title');
      const modalTextP = document.querySelector('.modal__text');
      const modalBadgeImg = document.querySelector('.modal__badge');
      let rating = [];
      let text = '';
      let badge = true;

      // Clicks “NO”
      if (event.currentTarget.innerHTML === 'No') {
        // Video not started
        if (Cookies.get('video') !== 'true') {
          rating = ['Compassion', 'Warrior'];
          text = `<strong>${
            !!Cookies.get('name') ? `Wow! ${Cookies.get('name')}, you ` : 'You '
          }didn’t even need to watch the footage to know that VSD+ is inhumane and should never have been approved!</strong> If only the American Medical Veterinary Association (AVMA) was as kind as you—millions of animals could have been spared a slow and painful death by suffocation and heat stroke. Together we can change this. Take action now to help end this cruelty.`;
          updateAsa('c', 'vsd_choice_no_novideo');
        }
        // Video started
        else {
          rating = ['Kindness', 'Champion'];
          text = `<strong>${
            !!Cookies.get('name') ? `${Cookies.get('name')}, you ` : 'You '
          }saw the evidence (even though it’s hard to watch!), and now you know for sure that VSD+ is inhumane and should never have been approved.</strong> If only the American Medical Veterinary Association (AVMA) was as compassionate as you—millions of animals could have been spared a slow and painful death by suffocation and heat stroke. Together we can change this. Take action now to help end this cruelty.`;
          updateAsa('c', 'vsd_choice_no_withvideo');
        }
        badge = true;
      }
      // Clicks "Yes"
      else {
        // Video not started
        if (Cookies.get('video') !== 'true') {
          rating = ['Ignorance', 'is Bliss'];
          text = `<strong>${
            !!Cookies.get('name') ? `Wow! ${Cookies.get('name')}, we ` : 'We '
          } know this footage is hard to watch.</strong> No one wants to see a chicken frantically flapping against the walls of her enclosure, thrashing and gasping for air. But the sad truth is that’s what it looks like when an animal is dying of deliberately induced heat stroke and suffocation. And right now, millions of chickens are dying in this horrific manner because the AVMA won’t change its endorsement of VSD+ to support animal welfare. We know this isn’t right. But together, we can make a change. Take action now to help end this cruelty.`;
          updateAsa('c', 'vsd_choice_yes_novideo');
        }
        // Video started
        else {
          rating = ['Ruthless', 'Researcher'];
          text = `<strong>${
            !!Cookies.get('name') ? `${Cookies.get('name')}, you ` : 'You '
          }just took a bold step and saw what VSD+ is like for chickens.</strong> It’s hard to watch a frantic animal thrashing and gasping for air. But the sad truth is that’s what it looks like when an animal is dying of deliberately induced heat stroke and suffocation. And right now, millions of chickens are dying in this horrific manner because the AVMA won’t change its endorsement of VSD+ to support animal welfare. There’s still time to make a compassionate choice! Take action now to help end this cruelty.`;
          updateAsa('c', 'vsd_choice_yes_withvideo');
        }
        badge = false;
      }

      if (rating.length) {
        modalRatingH2.removeAttribute('hidden');
        modalRatingPreTitle.removeAttribute('hidden');
        modalRatingH2.innerHTML = rating
          .map(
            (block) => `<span class="modal__title-block">${block}</span><br />`
          )
          .join('');
      } else {
        modalRatingPreTitle.setAttribute('hidden', 'true');
        modalRatingH2.setAttribute('hidden', 'true');
      }

      modalTextP.innerHTML = text;
      if (badge) {
        modalBadgeImg.removeAttribute('hidden');
      } else {
        modalBadgeImg.setAttribute('hidden', 'true');
      }

      modal.classList.add('modal--open');
      const exits = modal.querySelectorAll('[data-modal-close]');

      exits.forEach((exit) => {
        exit.addEventListener('click', () => {
          modal.classList.remove('modal--open');
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          modal.classList.remove('modal--open');
        }
      });
    });
  });
};

export default modal;
